import iconAlot from './../images/icon-sunlight.svg';
import iconAlotHover from './../images/icon-sunlight-white.svg';
import iconSome from './../images/icon-sunlight-some.svg';
import iconSomeHover from './../images/icon-sunlight-some-white.svg';
import iconNotMuch from './../images/icon-sunlight-notmuch.svg';
import iconNotMuchHover from './../images/icon-sunlight-notmuch-white.svg';
import iconUncertain from './../images/icon-sunlight-uncertain.svg';
import iconUncertainHover from './../images/icon-sunlight-uncertain-lightgrey.svg';

const icons = [
  { name: 'alot', path: iconAlot },
  { name: 'alotHover', path: iconAlotHover },
  { name: 'some', path: iconSome },
  { name: 'someHover', path: iconSomeHover },
  { name: 'notmuch', path: iconNotMuch },
  { name: 'notmuchHover', path: iconNotMuchHover },
  { name: 'uncertain', path: iconUncertain },
  { name: 'uncertainHover', path: iconUncertainHover },
];

export default icons;
